import { DEFAULT_DECK_AVATAR } from "../../constants/images";

/**
 * Normaliza un deck del catálogo (catalog.allDecks) al formato esperado por los componentes del Social Hub.
 * Los decks se cargan en catalog.allDecks al iniciar la app (fetchAllDecks).
 */
export function normalizeDeckForOptions(deck) {
  if (!deck) return null;
  const id = deck?.sourceId || deck?._id;
  const label = deck?.key || deck?.title || id || "";
  const normalized = {
    ...deck,
    _id: id,
    key: deck?.key || deck?.title,
    title: deck?.title || deck?.key,
    avatar: deck?.avatar || deck?.imageSizes || {
      miniUrl: deck?.imageUrl || deck?.avatarUrl || DEFAULT_DECK_AVATAR,
      smallUrl: DEFAULT_DECK_AVATAR,
      normalUrl: DEFAULT_DECK_AVATAR,
      mediumUrl: DEFAULT_DECK_AVATAR,
    },
    translations: deck?.translations || deck?.titleTranslations,
    subCategory: deck?.subCategory || (deck?.category ? { category: deck.category } : {}),
  };
  return { label, value: label, deck: normalized };
}

/**
 * Convierte catalog.allDecks al array de opciones para DropdownSearch.
 */
export function getDeckOptionsFromCatalog(allDecks) {
  const decks = allDecks || [];
  return decks.map(normalizeDeckForOptions).filter(Boolean);
}
